import { z } from "zod";

/**
 * Next.js browser start-up hook: runs before the app's own code, so before any schema is built.
 *
 * Zod compiles a faster object parser with `new Function` where it may, and finds out once by trying `Function("")`. The pages'
 * Content-Security-Policy allows no 'unsafe-eval' (lib/contentSecurityPolicy.ts), so that try is blocked: Zod catches it, but the
 * browser still reports it (the console's "string evaluation" error and a `script-src blocked=eval` line at /api/csp-report) on
 * every page that builds a schema. Without the compiled parser Zod never tries, and parses the same.
 */
z.config({ jitless: true });
